module.exports = __webpack_public_path__ + "static/media/unselected.b4db18ac.svg";